// no itx for this file
import Channel from "../models/Channel";
import Device from "../models/Device";
import Logger from "../Logger";
import { ChannelType, areChannelTypesCompatible, channelTypeInfo } from "../models/ChannelType";

import Button from "../models/Button";
import ButtonChannel from "../models/ButtonChannel";

import { showToast } from "../components/Toasts";
import Signal from "../models/Signal";
import { TAG_ENVIRONMENT, TAG_MANUAL_SIGNALS, TAG_TEMPERATUR } from "../models/Constants";

const logger = new Logger("UpdateChannels");

export function mapKnxChannelsToRequieremntChannels(targetDevice: Device) {
  const requiredChannelsRaw = targetDevice.channels.sortIntBy("index");
  let requiredChannels = requiredChannelsRaw.filter(
    (channel) => channel.getConnectedConsumer() != undefined || channel.getConnectedMultiplexers().length > 0,
  );

  const knxChannels = targetDevice.knxChannels.sortIntBy("index").filter((channel) => channel.signals.size > 0);

  logger.log("createMapping: requiered Channels: ");

  requiredChannels.forEach((requiredChannel) => {
    logger.log(`${requiredChannel.name} ${requiredChannel.channelType}`);
    requiredChannel.mappedChannel = undefined;
  });

  logger.log("createMapping: knx Channels: ");
  knxChannels.forEach((knxChannel) => {
    logger.log(`${knxChannel.name} ${knxChannel.channelType}`);
  });

  function insertMatch(debugId: string, requiredChannel: Channel, knxChannel: Channel) {
    requiredChannel.mappedChannel = knxChannel;

    requiredChannel.knxChannelId = knxChannel.knxChannelId;

    requiredChannel.index = knxChannel.index;

    if (!requiredChannel.isButtonChannel) {
      requiredChannel.tag = knxChannel.tag;
    }

    if (requiredChannel.channelType == ChannelType.FromKnxChannel) {
      requiredChannel._channelType = knxChannel.channelType;
    }

    logger.log(
      `insert match(${debugId}) req:${requiredChannel.tag} ${requiredChannel.name} -/> knx: ${knxChannel.tag} ${knxChannel.name}`,
    );

    knxChannel.raiseOnUpdateUi();
  }

  for (let s = 0; s < requiredChannels.length; s++) {
    const requiredChannel = requiredChannels[s];
    requiredChannel.mappedChannel = undefined;
  }

  //
  // remove all requiermentChannels with no connections
  //
  // MWE 4.3.2024
  //  Das kann man so nicht tun!
  //  dadurch werden beim löschen einer Verbindung mit anschließendem Redo neu Kanäle erzeugt.
  //  Diese stimmen aber nicht mit den Kanälen überein die an der gelöschten verbindung "hängen" !!!
  //  Daher für jetzt: tot gelegt. man muß schauen welche auswirkungen das sonst hat...
  //

  // for (let s = 0; s < requiredChannels.length; s++) {
  //   const requiredChannel = requiredChannels[s];
  //   if (requiredChannel.connections.size == 0) {
  //     targetDevice.channels.remove(requiredChannel);
  //   }
  // }

  //// Ende mwe 4.3.2020

  requiredChannels = targetDevice.channels.sortIntBy("index");

  //
  // dont touch import channel
  //
  const importedChannelTag = "@I";
  requiredChannels = requiredChannels.filter((channel) => !channel.tag.startsWith(importedChannelTag));

  ////////////////////////////////////////////////////////////////////////////
  // 1. All channels with eqal knxChannelId

  for (let s = 0; s < requiredChannels.length; s++) {
    const requiredChannel = requiredChannels[s];
    if (requiredChannel.knxChannelId) {
      const knxChannel = knxChannels.find(
        (knxChannel) =>
          !knxChannel.isDeleted &&
          knxChannel.mappedChannel == undefined &&
          knxChannel.knxChannelId == requiredChannel.knxChannelId &&
          areChannelTypesCompatible(knxChannel.channelType, requiredChannel.channelType, targetDevice),
      );

      if (knxChannel) {
        insertMatch("A", requiredChannel, knxChannel);
      }
    }
  }

  ////////////////////////////////////////////////////////////////////////////
  // 1b. Channels whose KNX channeltype changed
  //
  // When a parameter changes a channel from one type to another  the knxChannelId may differ
  // because KNX channel names change. Instead we match by positional tag
  // ("01", "02" …) which is stable. The requirement channel's type is updated
  // so that checkAllConnectionsAllowed() can clear the forbidden flag on any
  // attached consumer.

  for (let s = 0; s < requiredChannels.length; s++) {
    const requiredChannel = requiredChannels[s];
    if (requiredChannel.mappedChannel == undefined && requiredChannel.tag) {
      const reqInfo = channelTypeInfo(requiredChannel.channelType);
      const knxChannel = knxChannels.find(
        (knxChannel) =>
          !knxChannel.isDeleted && knxChannel.mappedChannel == undefined && knxChannel.tag == requiredChannel.tag,
      );

      if (knxChannel) {
        requiredChannel._channelType = knxChannel.channelType;
        insertMatch("A2", requiredChannel, knxChannel);
      }
    }
  }

  ////////////////////////////////////////////////////////////////////////////
  //
  // Map Environment Channel
  //

  const requiredEnvironmentChannel = requiredChannels.find((c) => c.channelType == ChannelType.Environment);
  const knxEnvironmentChannel = knxChannels.find((c) => c.channelType == ChannelType.Environment);

  if (requiredEnvironmentChannel && knxEnvironmentChannel) {
    insertMatch("A1", requiredEnvironmentChannel, knxEnvironmentChannel);
  }
  ////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////
  // 2. All channels  equal channel type

  for (let s = 0; s < requiredChannels.length; s++) {
    const requiredChannel = requiredChannels[s];
    if (requiredChannel.mappedChannel == undefined) {
      const knxChannel = knxChannels.find(
        (knxChannel) =>
          !knxChannel.isDeleted &&
          knxChannel.mappedChannel == undefined &&
          areChannelTypesCompatible(knxChannel.channelType, requiredChannel.channelType, targetDevice),
      );

      if (knxChannel) {
        insertMatch("B", requiredChannel, knxChannel);
      }
    }
  }

  ////////////////////////////////////////////////////////////////////////////
  // 3. All knx channels without mapping
  // map to a requierment channel with type unkown
  //

  for (let s = 0; s < knxChannels.length; s++) {
    const knxChannel = knxChannels[s];
    if (knxChannel.requestChannel == undefined) {
      let firstRequiermentChannelWithTypeUnkown: Channel | undefined = requiredChannels.find(
        (requirementChannel) =>
          !requirementChannel.isDeleted &&
          requirementChannel.mappedChannel == undefined &&
          requirementChannel.channelType == ChannelType.Unknown,
      );

      //
      // if we dont find a requierement channel, create a new one
      //
      if (!firstRequiermentChannelWithTypeUnkown && knxChannel.channelType != ChannelType.Unknown) {
        firstRequiermentChannelWithTypeUnkown = new Channel({ isRequestChannel: true }, targetDevice);
        targetDevice.channels.add(firstRequiermentChannelWithTypeUnkown);
      }

      if (firstRequiermentChannelWithTypeUnkown) {
        firstRequiermentChannelWithTypeUnkown.channelType = knxChannel.channelType;
        insertMatch("B", firstRequiermentChannelWithTypeUnkown, knxChannel);
      }
    }
  }

  if (targetDevice.isActor) {
    //
    // remove all requiermentChannels with channelType Unkown and no connections and no connected signals
    //

    for (let s = 0; s < requiredChannels.length; s++) {
      const requiredChannel = requiredChannels[s];
      if (
        (requiredChannel.channelType == ChannelType.Unknown || requiredChannel.mappedChannel == undefined) &&
        requiredChannel.connections.size == 0 &&
        !requiredChannel.hasConnectedSignals
      ) {
        requiredChannel.mappedChannel = undefined;
        targetDevice.channels.remove(requiredChannel);
      }
    }
  }
}

export function cleanupSignals(targetDevice: Device) {
  targetDevice.channels.forEach((channel) => cleanupChannelSignals(channel));
}

//
// remove existing signals, without knxSignal (match by number)
//
export function cleanupChannelSignals(requestChannel: Channel) {
  requestChannel.assetIsRequestChannel();

  // ManualSignals channels are restored by moveManualSignals() which runs before cleanupSignals().
  // If moveManualSignals() could not find the KNX counterpart (e.g. the signal ended up in a
  // numbered channel instead of TAG_SPECIAL), the new KNX channel will be empty.  In that case
  // we must NOT remove the request signals here – otherwise the manual connection is permanently
  // lost and cannot be recovered on the next rebuild.
  if (requestChannel.channelType === ChannelType.ManualSignals) return;

  const knxChannel = requestChannel.knxChannel;
  if (knxChannel) {
    const requestSignals = requestChannel.signals.asArray();
    const knxSignals = knxChannel.signals;

    //
    // remove all signals without knxSignal
    //

    requestSignals.forEach((requestSignal) => {
      const knxSignal = knxSignals.findFirst((knxSignal) => knxSignal.number == requestSignal.number);
      if (!knxSignal) {
        requestChannel.signals.removeWithoutUpdate(requestSignal);
      }
    });

    //
    // remove dumplikate signal (numbers)
    //
    // if one duplicate has groupAddresses and the othher not,
    // => remove the one without groupAddresses
    //
    // if both have groupAddresses, or both dont have any groupadress
    // => remove the first one
    //

    const sortedSignals = requestChannel.signals.sortIntBy("number");

    let lastSignal = sortedSignals[0];
    for (let i = 1; i < sortedSignals.length; i++) {
      const signal = sortedSignals[i];
      if (signal) {
        if (signal.number == lastSignal.number) {
          if (signal.groupAddresses.length == 0 && lastSignal.groupAddresses.length != 0) {
            requestChannel.signals.removeWithoutUpdate(signal);
          } else {
            requestChannel.signals.removeWithoutUpdate(lastSignal);
            lastSignal = signal;
          }
        } else {
          lastSignal = signal;
        }
      }
    }
  }
}

function insertButtonChannelMatch(
  button: Button,
  tag: string,
  requiredChannel: Channel | undefined,
  knxChannel: Channel,
  fromScript: boolean,
) {
  if (!requiredChannel) {
    //
    // create new requiredChannel
    //

    requiredChannel = (button as Button).createNewRequestChannel();

    requiredChannel.tag = tag;
    requiredChannel._channelType = knxChannel.channelType;

    if (knxChannel.channelType == ChannelType.Unknown) {
      if (fromScript) {
        requiredChannel._channelType = knxChannel._channelType = ChannelType.UnknownMapWithScript;
      }
    }
  } else {
    if (knxChannel.channelType == ChannelType.Unknown || knxChannel.channelType == ChannelType.GenericValue) {
      knxChannel.applyChannelTypeFromRequestChannel(requiredChannel.channelType);
    }
  }

  if (knxChannel.isStatusChannel) {
    requiredChannel._channelType = knxChannel.channelType;
    // requiredChannel.tag = "S" + tag.substring(1);
  }

  if (requiredChannel.isButtonChannel) {
    (requiredChannel as ButtonChannel).isVirtualRocker = (knxChannel as ButtonChannel).isVirtualRocker;
  }

  if (requiredChannel.channelType == ChannelType.FromKnxChannel) {
    requiredChannel._channelType = knxChannel.channelType;
  }

  requiredChannel.mappedChannel = knxChannel;
  requiredChannel.index = knxChannel.index;
  logger.log(
    `channelMatch: req= ${requiredChannel.tag} ${requiredChannel.name} -/> knx= ${knxChannel.tag} ${knxChannel.name}`,
  );

  knxChannel.raiseOnUpdateUi();
} // insertMatch

export function mapKnxChannelsToRequieremntChannelForButton(button: Button) {
  const knxChannels = button.knxChannels
    .findAsArray(
      (c) =>
        ![ChannelType.Unknown, ChannelType.Environment, ChannelType.General, ChannelType.Disabled].includes(
          c.channelType,
        ) ||
        c.tag.startsWith("T") ||
        c.tag.startsWith("A"), // Channel is defined by Script, or is an actor channel
    )
    .sort((a, b) => {
      if ((a.name + b.name).includes("DUMMY")) {
        return a.knxChannelTypeProperty?.id.localeCompare(b.knxChannelTypeProperty?.id ?? "") ?? 0;
      }
      return a.name.localeCompare(b.name, "en", { numeric: true }); // sort A1, A2, A10 korrect
    })
    .filter(
      (knxChannel) =>
        knxChannel.channelType != ChannelType.General &&
        knxChannel.channelType != ChannelType.TemperatureMeasurement &&
        knxChannel.channelType != ChannelType.Environment,
    );

  const requiredChannels = button.channels
    .sortBy("tag")
    .filter(
      (requiredChannel) =>
        requiredChannel.channelType != ChannelType.General &&
        requiredChannel.channelType != ChannelType.TemperatureMeasurement &&
        requiredChannel.channelType != ChannelType.Environment,
    );

  ////////////////////////////////////////////////////////////////////////////////////////

  //
  // some sanitary checks
  //

  button.channels.forEach((requiredChannel) => {
    requiredChannel.assetIsRequestChannel();
  });

  button.knxChannels.forEach((knxChannel) => {
    knxChannel.assetIsKnxChannel();
  });

  ////////////////////////////////////////////////////////////////////////////////////////

  //
  // clear current mapping
  //

  button.channels.forEach((requiredChannel) => {
    requiredChannel.knxChannel = undefined;
  });

  //
  // start new mapping
  //

  if (requiredChannels[0]?.tag.startsWith("0")) {
    mapFromOldEstadaVersionBySignals(requiredChannels, knxChannels);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  // Map TemperatureMeasurement and Environment
  //

  const knxTemperatureMeasurement_channel = button.knxChannels.findFirst(
    (c) => c.channelType == ChannelType.TemperatureMeasurement,
  );
  const knxEnvironment_channel = button.knxChannels.findFirst((c) => c.channelType == ChannelType.Environment);

  const requiredTemperatureMeasurement_channel = button.channels.findFirst(
    (c) => c.channelType == ChannelType.TemperatureMeasurement,
  );
  const requiredEnvironment_channel = button.channels.findFirst((c) => c.channelType == ChannelType.Environment);

  if (knxTemperatureMeasurement_channel) {
    insertButtonChannelMatch(
      button,
      TAG_TEMPERATUR,
      requiredTemperatureMeasurement_channel,
      knxTemperatureMeasurement_channel,
      false,
    );
  }

  if (knxEnvironment_channel) {
    insertButtonChannelMatch(button, TAG_ENVIRONMENT, requiredEnvironment_channel, knxEnvironment_channel, false);
  }

  //
  // Map ManualSignals
  //
  const knxManualSignals_channel = button.knxChannels.findFirst((c) => c.channelType == ChannelType.ManualSignals);
  const requiredManualSignals_channel = button.channels.findFirst((c) => c.channelType == ChannelType.ManualSignals);
  if (knxManualSignals_channel && requiredManualSignals_channel) {
    insertButtonChannelMatch(
      button,
      TAG_MANUAL_SIGNALS,
      requiredManualSignals_channel,
      knxManualSignals_channel,
      false,
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  // Map Chanenels with script
  //

  if (true) {
    // button.template?.knxProductData.hasScript_mapSignalToTag) {
    //
    // Die SignalNummer wurden vom Script direkt auf ChannelTags ("T01", "T02L" etc) gemappet.
    //
    // In diesem Fall wirden die knxChannels bereits mit dem "richtigen" Tag  ("T01", ...) versehen
    // Daher brauchen wir nur noch Tag auf Tag mappen.
    //

    for (let s = 0; s < knxChannels.length; s++) {
      const knxChannel = knxChannels[s];
      let tag = knxChannel.tag;
      if (tag.startsWith("T") || tag.startsWith("A") || tag.startsWith("S")) {
        // AktorChannel-Prefix
        let requiredChannel = requiredChannels.find((c) => c.tag == tag) as ButtonChannel;

        // Fallback for decentral actors: a connection may have been drawn before the template
        // was assigned. In that case the channel may have a different tag (e.g. "??").
        // After assertChannelsAreButtonChannels() all channels are ButtonChannel, so we must
        // not filter on !isButtonChannel. Re-tag it so the existing consumer connection is
        // preserved instead of creating an orphaned channel.
        if (!requiredChannel && tag.startsWith("A")) {
          const fallbackChannel = requiredChannels.find(
            (c) => !c.mappedChannel && c.connections.size > 0,
          ) as ButtonChannel;
          if (fallbackChannel) {
            fallbackChannel.tag = tag;
            requiredChannel = fallbackChannel;
          }
        }

        insertButtonChannelMatch(button, tag, requiredChannel, knxChannel, true);
      }
    }
  }

  //
  // handle Buttons (partiel) without customizing for ChannelMapping
  //

  let s = 1;
  let t = 1;

  for (const knxChannel of knxChannels) {
    if (knxChannel.requestChannel) {
      const requestChannel = knxChannel.requestChannel;
      const buttonNumber = (requestChannel as ButtonChannel).buttonNumber;
      if (requestChannel.isStatusChannel) {
        s = Math.max(s, buttonNumber + 1);
      } else {
        t = Math.max(t, buttonNumber + 1);
      }
    }
  }

  const supportsSplitRocker = button.baseProps.buttonBaseProps?.supportsSplitRocker;

  let leftUsed = false;
  for (const knxChannel of knxChannels) {
    if (!knxChannel.requestChannel) {
      let tag: string;
      let nanTagFound = false;

      if (knxChannel.isStatusChannel) {
        if (isNaN(s)) {
          tag = knxChannel.tag;
          nanTagFound = true;
        } else {
          tag = "S" + ("0" + s++).slice(-2);
        }
      } else {
        if (isNaN(t)) {
          tag = knxChannel.tag;
          nanTagFound = true;
        } else {
          tag = "T" + ("0" + t++).slice(-2);
        }
      }

      if (!knxChannel.requestChannel) {
        let requiredChannel = requiredChannels.find((c) => c.tag == tag) as ButtonChannel;

        if (!nanTagFound && !supportsSplitRocker && !requiredChannel) {
          //
          // "T01" not found, try "T01L" or "T01R"
          //
          if (!leftUsed) {
            requiredChannel = button.channels.findFirst((c) => c.tag == tag + "L") as ButtonChannel;
            if (requiredChannel) {
              leftUsed = true;
              t--;
            }
          } else {
            requiredChannel = button.channels.findFirst((c) => c.tag == tag + "R") as ButtonChannel;
            leftUsed = false;
          }
        }

        if (requiredChannel?.knxChannel) {
          showToast({
            isError: true,
            text: `Channel ${requiredChannel.tag} is already mapped to ${requiredChannel.knxChannel.tag}`,
          });
        } else {
          insertButtonChannelMatch(button, tag, requiredChannel, knxChannel, false);
        }
      }
    }
  }

  for (const requiredChannel of button.channels.asArray()) {
    requiredChannel.flagErrors(
      { noMatchingKNXChannel: "" },
      requiredChannel.channelType != ChannelType.Disabled &&
        !requiredChannel.knxChannel &&
        requiredChannel.connections.size > 0,
    );

    if (!requiredChannel.knxChannel && requiredChannel.connections.size == 0) {
      if (requiredChannel.tag != "@I" && requiredChannel.signals.size == 0) {
        requiredChannel.delete();
      }
    }
  }

  function mapFromOldEstadaVersionBySignals(requiredChannels: Channel[], knxChannels: Channel[]) {
    function channelHasSignalNumber(channel: Channel, number: string): boolean {
      return channel.signals.findFirst((signal) => signal.number === number) != undefined;
    }

    function findKnxChannelBySignals(signals: Signal[], knxChannels: Channel[]) {
      for (let knxChannel of knxChannels) {
        for (const signal of signals) {
          let found = channelHasSignalNumber(knxChannel, signal.number);
          if (found) return knxChannel;
        }
      }
      return undefined;
    }

    requiredChannels.forEach((requiredChannel) => {
      const knxChannel = findKnxChannelBySignals(requiredChannel.signals.asArray(), knxChannels);
      if (knxChannel) {
        requiredChannel.tag = knxChannel.tag;
        insertButtonChannelMatch(button, knxChannel.tag, requiredChannel, knxChannel, false);
      }
    });
  }
}
